import React, { useContext } from 'react';
import { AppContext, IAppContext } from 'appState/appContext';
import { WatchFullInfoContext, IWatchFullInfoContext } from '../../watchFullInfoState/watchFullInfoContext';
import { pushWatchNotifications } from 'backend/watches';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import classNames from 'classnames';
import style from './ModalWindows.module.scss';

export const ModalWindows: React.FC = () => {
	const { showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const { changeTypeOfModalWindow, setDataForPush, dataForPush, typeOfModalWindow } =
		useContext<IWatchFullInfoContext>(WatchFullInfoContext);
	const containerClasses = classNames(style.container, { [style.visible]: typeOfModalWindow });

	const sendPush = async () => {
		if (dataForPush && typeOfModalWindow) {
			try {
				showLoader();
				await pushWatchNotifications({
					serialNumber: dataForPush.serialNumber,
					data: {
						...dataForPush.data,
					},
				});
				changeTypeOfModalWindow('success');
			} catch (err) {
				changeTypeOfModalWindow('error');
			} finally {
				hideLoader();
			}
		}
	};

	const handleCloseModal = () => {
		changeTypeOfModalWindow(null);
		setDataForPush(null);
	};

	return (
		<div className={containerClasses} data-test="ModalWindows">
			<ModalToConfirm
				onConsentEvent={sendPush}
				onFailureEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'confirm'}
				description="pushInfo"
				typeOfInfoIcon="toConfirmPush"
			/>
			<ModalSentSuccessfully
				onConsentEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'success'}
				description="pushSuccessfully"
			/>
			<ModalSentError
				onConsentEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'error'}
				description="errorWhileSendingPush"
			/>
		</div>
	);
};
